const initialState = { events: [], currentevent: null, resultevent: null, total: 0 }

export const eventsReducer = (state = initialState, action) => {
	switch (action.type) {
        case 'EVENT_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                events: action.payload.events,
                total: action.payload.total
            }
		case 'EVENT_LOAD_CURRENT':
			return {
				...state,
				currentevent: action.payload
			}
		case 'EVENT_LOAD_ERROR':
			return {
				...state,
				currentevent: null,
				resultevent: 'error'
			}
		case 'EVENT_ADD_SUCCESS':
			return {
				...state,
				events: [action.payload.event, ...state.events],
				currentevent: action.payload.event,
				resultevent: action.payload.message
			}
		case 'EVENT_EDIT_SUCCESS':
			return {
				...state,
				events: state.events.map(ev =>
					ev._id === action.payload.event._id ? action.payload.event : ev
				),
				currentevent: action.payload.event,
				resultevent: action.payload.message
			}
		case 'EVENT_WRONG_SUCCESS':
			return {
				...state,
				resultevent: action.payload.message
			}
		case 'EVENT_RESET_RESULT':
			return {
				...state,
				resultevent: null
			}
        case 'EVENT_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'EVENT_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
		case 'EVENT_GET_BY_ID':
			return {
				...state,
				currentevent: action.payload
			}
		default:
			return state
	}
}
